import { useQuery } from "@tanstack/react-query";
import { getProduct } from "../api";

export const useGetProduct = (categoryId?: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["PRODUCT", categoryId],
    queryFn: () => getProduct(categoryId),
    select: ({ data }) => data,
  });

  return { product: data, isLoading };
};
